import { connect } from "react-redux";
import { useEffect, useState } from "react";
import { UserDetailsViewModel } from "../../configuration/api/apiSchema";
import { AuthData } from "../../pages/Auth/reducer";
import { HandymanAppState } from "../../configuration/redux/reducers";
import { getUserDetails } from "../../pages/Auth/actions";
import { Snackbar, Alert } from "@mui/material";

interface PassedProps {
  children: React.ReactNode;
}

interface DispatchFromProps {
  getUserDetails: () => void;
}

interface StateFromProps {
  authData?: AuthData;
  userDetails?: UserDetailsViewModel;
}

type Props = PassedProps & DispatchFromProps & StateFromProps;

const OnboardingProvider: React.FC<Props> = (props) => {
  const { authData, children } = props;
  const [alertVisible, setAlertVisible] = useState(false);

  useEffect(() => {
    if (authData?.status === "pendingSelectCategories") {
      // Show alert
      setAlertVisible(true);

      // If we're *not* already on /select-categories, do a hard reload
      if (window.location.pathname !== "/select-categories") {
        window.location.href = "/select-categories";
      }
    }
  }, [authData]);

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertVisible(false);
  };

  return (
    <>
      {children}

      <Snackbar
        open={alertVisible}
        autoHideDuration={6000}
        onClose={handleClose as any}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity="info" sx={{ width: "100%" }}>
          Action required: Please select your categories to proceed.
        </Alert>
      </Snackbar>
    </>
  );
};

const mapStateToProps = (state: HandymanAppState): StateFromProps => ({
  authData: state.user.authData,
  userDetails: state.user.userDetails,
});

export default connect<
  StateFromProps,
  DispatchFromProps,
  PassedProps,
  HandymanAppState
>(mapStateToProps, {
  getUserDetails,
})(OnboardingProvider);
